import { useMutation } from '@tanstack/react-query'

import { syncMoneytreeAccessToken } from '@src/api'
import { DefaultApiSyncMoneytreeAccessTokenRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useSyncMoneytreeAccessToken = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiSyncMoneytreeAccessTokenRequest) =>
      syncMoneytreeAccessToken(axiosInstance, params),
  })
}
